import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import React, { useRef } from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import StarsIcon from "@mui/icons-material/Stars";
import { useEffect, useState, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import PreviewIcon from "@mui/icons-material/Preview";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EditIcon from "@mui/icons-material/Edit";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../components/Loader";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import KeyIcon from "@mui/icons-material/Key";
import Divider from "@mui/material/Divider";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { useDispatch, useSelector } from "react-redux";

import dayjs from "dayjs";

import moment from "moment";
import { common_axios } from "../../../App";
import CheckBox from "../UserManagement/Tables/CheckBox";
import DashboradTable from "../Dashboard/DashboradTable";
import { ArrowForwardIosTwoTone } from "@mui/icons-material";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import CheckBox from "./CheckBox";

export default function HrManageEmployee() {
  const [open, setOpen] = useState(false);
  const [openn, setOpenn] = React.useState(false);
  const [enabledisable, setenabledisable] = React.useState(undefined);
  const [location, setLocation] = React.useState({
    leaveType: "",
    reason: "",
    showlastdiv: false,
  });

  const customId1 = "custom-id-yess";
  const forgotRefmodal = useRef(null);
  const forgotRef = useRef(null);
  const approvvalEnable = useRef(null);
  const closeeee = useRef(null);
  const handleClose = () => {
    setOpenn(false);
  };

  const handleEnableDesable = async (cell) => {
    await setenabledisable(cell?.row?.original);
    // console.log("enabledisable", cell?.row?.original);
    await approvvalEnable?.current.click();
  };

  // console.log("enabledisable", enabledisable);

  const [Switches, setSwitches] = useState();
  const [Edittt, setEdittt] = useState(undefined);
  const [EditttBankdetails, setEditttBankdetails] = useState(undefined);

  // console.log("kk", EditttBankdetails, Edittt);

  const handleSwitchChange = (event, index, cellObject, indexx) => {
    // console.log("hhhh", event.target.checked, index);
    const enabled = cellObject.enabled;

    let dattaa = [...data];

    // console.log({ dattaa });

    dattaa[indexx].enabled = !dattaa[indexx].enabled;

    setData(dattaa);
    let newSwitches = { ...cellObject, enabled: event.target.checked };

    // const newSwitches = [...switches];
    newSwitches[index].enabled = event.target.checked;
    setSwitches(newSwitches);
  };

  // console.log(Switches, "jjjjj");

  const [checked, setChecked] = React.useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [contactus, setContactus] = useState({
    // name: "",
    // email: "",
    userid: "",
    username: "",
    newpassword: "",
    confirmpassword: "",
  });

  // console.log("di", contactus);

  const forgotPassword = async (e) => {
    e.preventDefault();
    // try {
    //   setOpen(true);

    //   const res = await axios.post(
    //     `${process.env.REACT_APP_COMMON_API}/api/auth/v1/forgotPassword`,
    //     {
    //       userName: contactus.name,
    //       email: contactus.email,
    //     }
    //   );

    //   if (res.data.statusDescriptions.statusCode == 200) {
    //     setOpen(false);

    //     await handleClose();
    //     await setTimeout(() => {
    //       // toast.success(res.data.statusDescriptions.statusDescription, {
    //       //   theme: "colored",
    //       // });
    //       Swal.fire({
    //         icon: "success",
    //         // title: "Oops...",
    //         text: res.data.statusDescriptions.statusDescription,
    //         // footer: '<a href="">Why do I have this issue?</a>'
    //       });
    //     }, 100);
    //     localStorage.setItem("tokennn", res.data.forgotPasswordResponses.token);
    //     localStorage.setItem(
    //       "username",
    //       res.data.forgotPasswordResponses.username
    //     );
    //     localStorage.setItem("id", res.data.forgotPasswordResponses.userId);
    //     await forgotRefmodal.current.click();
    //   } else {
    //     setOpen(false);
    //     // await handleClose();
    //     await setTimeout(() => {
    //       // toast.error(res.data.statusDescriptions.statusDescription, {
    //       //   theme: "colored",
    //       // });
    //       Swal.fire({
    //         icon: "error",
    //         title: "Oops...",
    //         text: res.data.statusDescriptions.statusDescription,
    //         // footer: '<a href="">Why do I have this issue?</a>'
    //       });
    //     }, 100);
    //     await forgotRefmodal.current.click();
    //   }
    // } catch (error) {
    //   setOpen(false);
    //   // await handleClose();

    //   await forgotRefmodal.current.click();

    //   // await toast.error("Something Went Wrong ! Please check your network", {
    //   //   theme: "colored",
    //   //   customId1,
    //   // });
    //   Swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "Something Went Wrong ! Please check your network",
    //     // footer: '<a href="">Why do I have this issue?</a>'
    //   });
    // }
    forgotRefmodal.current.click();
    try {
      setOpen(true);
      const res = await axios.post(
        `${process.env.REACT_APP_COMMON_API}/api/auth/v1/update/password`,
        {
          username: contactus?.username,
          newPassword: contactus?.newpassword,
          userId: contactus?.userid,
        }
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // await toast.success(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // setTimeout(async () => {
        //   await history.replace("/");
        // }, 1000);
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const EnableDisabled = async () => {
    // e.preventDefault();

    try {
      setOpen(true);
      if (enabledisable.enabled == false) {
        const res = await common_axios.post(`attendance/v1/enableAndDisable`, {
          accountRequest: [{ ...enabledisable, enable: "true" }],
        });

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          await getAllEmployeesbyCSM();
          await handleClose();
          await setTimeout(() => {
            // toast.success(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        } else {
          setOpen(false);
          // await handleClose();
          await setTimeout(() => {
            // toast.error(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } else {
        const res = await common_axios.post(`attendance/v1/enableAndDisable`, {
          accountRequest: [{ ...enabledisable, enable: "false" }],
        });

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          await getAllEmployeesbyCSM();
          await handleClose();
          // await setTimeout(() => {
          //   toast.success(res.data.statusDescriptions.statusDescription, {
          //     theme: "colored",
          //   });
          // }, 100);
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        } else {
          setOpen(false);
          // await handleClose();
          await setTimeout(() => {
            // toast.error(res.data.statusDescriptions.statusDescription, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescriptions.statusDescription,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      }
    } catch (error) {
      setOpen(false);
      // await handleClose();

      // await toast.error("Something Went Wrong ! Please check your network", {
      //   theme: "colored",
      //   customId1,
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // console.log("dhi78", Edittt);

  const editdetails = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      const res = await common_axios.post(`/employee/v1/editEmployee`, {
        userId: Edittt?.id,
        email: Edittt?.email,
        mobileNo: Edittt?.mobileNo,
        address: Edittt?.address,
        aadharCard: Edittt?.aadharCard,
        accountNumber: EditttBankdetails && EditttBankdetails?.accountNumber,
        bank: EditttBankdetails && EditttBankdetails?.bank,
        ifscCode: EditttBankdetails && EditttBankdetails?.ifscCode,
        branch: EditttBankdetails && EditttBankdetails?.branch,
        panNumber: EditttBankdetails && EditttBankdetails?.panNumber,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // await modalMarkClose.current.click();
        // await AllCSM();
        closeeee.current.click();
        document.getElementById("homeee-tab").click();
        // await buttonCLick.current.click();
        await getAllEmployeesbyCSM();
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // x.toLocaleDateString()
      } else {
        setOpen(false);
        closeeee.current.click();
        document.getElementById("homeee-tab").click();
        await getAllEmployeesbyCSM();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      closeeee.current.click();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const [data, setData] = useState([]);
  const [showdata, setshowData] = useState(false);
  const [value, setValue] = React.useState(dayjs(new Date()));
  const [valuee, setValuee] = React.useState();
  const [ee1, setee1] = useState({
    dateform: null,
  });
  const [valueofLeavs, setvalueofLeavs] = useState("");

  const [datee, setdatee] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  const [daysDiff, setdaysDiff] = useState(1);
  var [date, setDate] = useState(new Date());
  const [employees, setEmployess] = useState([]);
  const [employeesValue, setEmployessValue] = useState(null);
  const [locationvalues, setlocationvalues] = useState(null);
  const [kunuVeer, setkunuVeer] = useState(false);
  const [valueee, setValueee] = React.useState(null);
  const [leavesByOthere, setleavesbyOther] = useState([]);
  const [employeeDetails, setemployeeDetails] = useState(undefined);
  const [viewattendance, setviewattendance] = useState(undefined);
  const [buttonsidable, setbuttonDisable] = useState(undefined);
  const [notdatafound, setnotdatafound] = useState(false);
  const [resetModal, setResetModal] = useState({
    year: new Date().getFullYear(),
    month: moment(new Date()).format("MM"),
  });

  const [UpdatePassword, setUpdatePassword] = useState(undefined);

  // console.log("UpdatePassword", UpdatePassword);

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });
  const mindate = moment(new Date()).subtract(7, "days");

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleChangee = (newValue) => {
    setValuee(newValue);
  };
  var date = moment(valuee?.$d);
  var now = moment(value?.$d);
  var duration = moment.duration(date.diff(now));
  var noofDays = duration.asDays();

  var stat = moment().format("MMMM Do YYYY, h:mm:ss a");

  useEffect(() => {
    setdaysDiff(Math.ceil(noofDays) + 1);
  }, [value?.$d, valuee?.$d]);

  const usermodal = JSON.parse(localStorage.getItem("usermodal"));

  const tabSwitch = useRef(null);
  const tabedit = useRef(null);

  const tabModal = async () => {
    await tabSwitch?.current?.click();
  };

  const Editt = async (cell) => {
    await resetValues.current.click();
    // console.log("dh8", cell.row.original);
    await setEdittt(cell.row.original);
    await setEditttBankdetails(cell.row.original?.bankDetails[0]);
    await tabedit?.current?.click();
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },

      //   {
      //     Header: "E-Mail",

      //     accessor: "email",
      //   },
      {
        Header: "Employee Name",

        accessor: "username",
        Cell: (cell) => (
          <>
            {cell.row.original.firstName && cell.row.original.lastName ? (
              <>
                <span>
                  {cell.row.original.firstName}
                  &nbsp;
                  {cell.row.original.lastName}
                </span>
              </>
            ) : cell.row.original.firstName ? (
              <>{cell.row.original.firstName}</>
            ) : cell.row.original.lastName ? (
              <>{cell.row.original.lastName}</>
            ) : (
              <>
                <span>Not Known</span>
              </>
            )}
          </>
        ),
      },
      {
        Header: "Designation",

        accessor: "designation",
      },

      {
        Header: "Payroll-Id",

        accessor: "payrollId",
      },

      {
        Header: "Status",

        accessor: "enabled",
        Cell: (cell) => {
          return (
            <>
              {/* {cell.row.original.enabled ? (
              <>
                <span class="badge badge_8 bg-success">Active</span>
              </>
            ) : (
              <>
                <span class="badge badge_8 bg-warning">De-Active</span>
              </>
            )} */}

              {/* </div> */}
              <div key={cell.row.original.id}>
                <Switch
                  checked={cell.row.original.enabled}
                  // onChange={(event) =>
                  //   handleSwitchChange(
                  //     event,
                  //     cell.row.original.id,
                  //     cell.row.original,

                  //     cell.row.index
                  //   )
                  // }
                  onClick={() => handleEnableDesable(cell)}
                />
                {/* <span>{item.label}</span> */}
              </div>
            </>
          );
        },
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          return (
            <>
              <Tooltip title="View Details">
                <IconButton
                  style={{ color: "#4C4234" }}
                  color="#4C4234"
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    editEmployeeModal(cell);
                    tabModal();
                  }}
                >
                  <PreviewIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="View Attendance">
                <IconButton
                  color="#4C4234"
                  style={{ color: "#4C4234" }}
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    ViewAttendance(cell);
                    viewAttendanceEmployeeModal(cell);
                    tabModal();
                  }}
                >
                  <CalendarMonthIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Change Password">
                <IconButton
                  color="#4C4234"
                  style={{ color: "#4C4234" }}
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    updatepassword(cell);

                    // document.getElementById("openForgot").click();
                  }}
                >
                  <KeyIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit">
                <IconButton
                  color="#4C4234"
                  style={{ color: "#4C4234" }}
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    Editt(cell);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            </>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );

  const markAttendence = async (e) => {
    try {
      setOpen(false);
      const res = await common_axios.post(`/attendance/markAttendance`, {
        userId: localStorage.getItem("UserId"),
        status: 1,
        userGroup: usermodal,
        userName: localStorage.getItem("usernamedisplayed"),
      });
      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        // markAttendacne();

        // await setLocation({
        //   ...location,
        //   showlastdiv: true,
        // });

        await setTimeout(async () => {
          await toast.success(res.data.statusDescriptions.statusDescription, {
            theme: "colored",
          });
        }, 100);
      } else {
        setOpen(false);
        // markAttendacne();
        await setTimeout(async () => {
          await toast.error(res.data.statusDescriptions.statusDescription, {
            theme: "colored",
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await setTimeout(async () => {
        await toast.error("Something went wrong !! Please check your network", {
          theme: "colored",
        });
      }, 100);
    }
  };

  const editEmployee = useRef(null);
  const viewAttendance = useRef(null);
  const markAttendacneref = useRef(null);

  const editEmployeeModal = async (cell) => {
    // console.log("dhuii", cell.row.original);
    await setemployeeDetails(cell.row.original);
    await setEditttBankdetails(cell.row.original?.bankDetails[0]);
    await editEmployee.current.click();
  };
  const viewAttendanceEmployeeModal = async (cell) => {
    await setviewattendance(cell.row.original);
    await viewAttendance.current.click();
  };

  const updatepassword = async (cell) => {
    await setUpdatePassword(cell.row.original);
    await setContactus({
      ...contactus,
      username: cell.row.original.username,
      userid: cell.row.original.username.id,
    });
    await document.getElementById("openForgot").click();
  };

  const markAttendacnmodal = async () => {
    await markAttendacneref.current.click();
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setSelectedFlatRows,
    setSelectedRowIds,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <CheckBox {...getToggleAllRowsSelectedProps()} id="thissss" />
            ),
            Cell: ({ row }) => (
              <CheckBox {...row.getToggleRowSelectedProps()} />
            ),
          },
          ...columns,
        ];
      });
    }
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const deletUser = async () => {
    // console.log({ selectedFlatRows });
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  // const markAttendacne = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`/attendance/viewAttendance`, {
  //       userId: localStorage.getItem("UserId"),
  //       year: datee.year,
  //       month: datee.month,
  //     });

  //     if (res.data.statusCode == 200) {
  //       setOpen(false);

  //       setData(res.data.attendanceEntity);

  //       res.data.attendanceEntity.map((e) => {

  //         setee1({
  //           ...e,
  //           dateform: moment(e.date).format("DD-MM-YYYY"),
  //         });
  //       });

  //     } else {
  //       setOpen(false);
  //       await toast.error(res.data.statusDescription.description, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpen(false);
  //     await toast.error("Something Went Wrong !! Please check your network ", {
  //       theme: "colored",
  //     });
  //   }
  // };

  useEffect(() => {
    // markAttendacne();

    getAllEmployeesbyCSM();
  }, []);

  const userGrop = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  // useEffect(() => {
  //   let newform = moment(new Date()).format("DD-MM-YYYY");
  //   console.log(newform, ee1?.dateform);

  //   if (ee1.dateform == newform) {
  //     setshyamCode(ee1);
  //   }
  // }, [ee1.dateform]);

  const getButtonAdd = useSelector(
    (datar) => datar?.EmployeeSlice?.employeebutton
  );

  const getAllEmployeesbyCSM = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `employee/v1/allEmployeesByOrganization?organizationName=${usermodal?.organization}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // console.log("hhoo", res.data.adminUserModels);
        // setEmployess(res.data.adminUserModels);
        setData(res.data.adminUserModels);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const ViewAttendance = async (cell) => {
    try {
      setOpen(true);
      const res = await common_axios.post(`/attendance/viewAttendance`, {
        userId: cell.row.original?.id,
        year: datee.year,
        month: datee.month,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // setkunuVeer(true);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  //   const openforgot =() =>{
  //     document.getElementById("openForgot").click();
  //   }

  useEffect(() => {
    getAllEmployeesbyCSM();
  }, []);

  const locationMasterEntities = JSON.parse(
    localStorage.getItem("usermodal")
  )?.locationMasterEntities;

  useEffect(() => {
    if (employeesValue == null || undefined) {
      setkunuVeer(false);
    }
  }, [employeesValue]);

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const leavesByOther = async (dataa1) => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `attendance/leavesByOther?userGroup=${userGrop}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        await setOpen(false);

        // let leavearr = [];
        // for (let i = 0; i < res.data.attendanceDetailsModels.length; i++) {
        //   const ele = res.data.attendanceDetailsModels[i];

        //   if (dataa1?.status != ele?.status) {
        //     leavearr.push(ele);
        //   }
        // }

        // console.log({ leavearr });

        await setleavesbyOther(res.data.attendanceDetailsModels);
      } else {
        await setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      await setOpen(false);
      // await toast.error("Something Went Wrong ! Please Check your NetWork");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong ! Please Check your NetWork",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  useEffect(() => {
    if (userGrop) {
      leavesByOther();
    }
  }, []);

  const modalMarkClose = useRef(null);

  const usergroup = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;
  const handleChanged = (newValue) => {
    setValueee(moment(newValue?.$d, "MMM-DD-YYYY").format("YYYY-MM-DD"));
  };

  const markAttendacneByCSM = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      let attendanceRequests = [];

      for (let i = 0; i < selectedFlatRows.length; i++) {
        let element = selectedFlatRows[i];

        element.original.fromDate = valueee;
        element.original.status = valueofLeavs;
        element.original.userId = element.original.id;
        element.original.usergroup = usergroup;

        element.original.username = localStorage.getItem("usernamedisplayed");
        attendanceRequests.push(element.original);
      }

      const res = await common_axios.post(`attendance/bulkMarkAttendance`, {
        attendanceRequests: attendanceRequests,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        await modalMarkClose.current.click();
        // await AllCSM();
        await getAllEmployeesbyCSM();
        // await buttonCLick.current.click();

        // await toast.success(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // x.toLocaleDateString()
      } else {
        setOpen(false);
        await modalMarkClose.current.click();
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      await modalMarkClose.current.click();
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // console.log("hhhd", Edittt?.firstName);

  const buttonCLick = useRef(null);
  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const resetValues = useRef(null);

  const resetter = () => {
    resetValues.current.click();
  };

  const validationSchema = yup.object({
    payrollid: yup.number("Enter your Payroll-Id").nullable(),
    // .min(10, "Payroll-Id should be of minimum 2 characters length")
    // .max(1000000, "Payroll-Id should be of maximum 7 characters length"),
    // .required("Payroll-Id is required"),
    unanumbar: yup.number("Enter your UAN-numbar").nullable(),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    branch: yup.string("Enter your Branch").nullable(),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    ifscCode: yup.string("Enter your IFSC-Code").nullable(),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Payroll-Id is required"),
    bank: yup.string("Enter your Bank").nullable(),
    // .min(10, "UAN-numbar should be of minimum 2 characters length")
    // .max(100000000000, "UAN-numbar should be of maximum 12 characters length")
    // .required("Bank Name isdesignation required"),
    accountNumber: yup
      .string("Enter your Account Number")
      // .required("Account Number is required")
      .matches(/^[0-9]{9,18}$/, {
        message: "Invalid Account Number Valid Example Like: 635802010014976",
      })
      .nullable(),
    //   .required("Last Name required"),
    // firstname: yup
    //   .string("Enter your First Name ")
    //   .min(2, "First Name should be of minimum 2 characters length")
    //   .required("First Name is required"),
    // // designation: yup
    // //   .string("Enter your Designation ")
    // //   .min(2, "Designation should be of minimum 2 characters length")
    // //   .required("Designation is required"),
    // username: yup
    //   .string("Enter Your Username")
    //   .min(3, "Username should be at least 3 characters long")
    //   .required("*Username is required")
    //   .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),
    emailaddress: yup.string().email("E-Mail must be valid").max(255),
    contact: yup
      .number("Enter your PhoneNumber")
      .min(1000000000, "PhoneNumber should be of minimum 10 characters length")
      .max(
        100000000000,
        "PhoneNumber should be of maximum 11 characters length"
      ),
    // .required("PhoneNumber is required"),
    adhaar: yup
      .string("Enter Your Aadhaar Number")
      // .required("Aadhaar Number Is Required")
      .matches(/^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/, {
        message: "Invalid Aadhaar Number Valid Example Like: 78XX 45XX 97XX",
      })
      .nullable(),
    pan: yup
      .string("Enter Your PAN Number")
      .matches(/(([A-Z]){5}([0-9]){4}([A-Z]){1}$)/, {
        message: "Invalid PAN Number Valid Example Like: ALWPG5809L",
        // excludeEmptyString: true,
      })
      .nullable(),
    address: yup.string("Enter Your Address"),
    // .min(2, "Employee Name should be of minimum 2 characters length")
    // .required("Enter Your Address"),
    // .matches(/(([A-Z]){5}([0-9]){4}([A-Z]){1}$)/, {
    //   message: "Invalid PAN Number Valid Example Like: ALWPG5809L",
    //   // excludeEmptyString: true,
    // }),
  });

  // console.log("EditttBankdetails", EditttBankdetails);

  const formik = useFormik({
    initialValues: {
      contact: Edittt?.mobileNo,
      username: Edittt?.username,
      emailaddress: Edittt?.email,
      payrollid: Edittt?.payrollId,
      unanumbar: Edittt?.uanNumber,
      adhaar: Edittt?.aadharCard
        ?.replace(/[^\dA-Z]/g, "")
        ?.replace(/(.{4})/g, "$1 ")
        .trim(),
      pan: EditttBankdetails?.panNumber,
      address: Edittt?.address,
      branch: EditttBankdetails?.branch,
      ifscCode: EditttBankdetails?.ifscCode,
      bank: EditttBankdetails?.bank,
      accountNumber: EditttBankdetails?.accountNumber,
      // contact: "",
      // username: "",
      // emailaddress: "",
      // payrollid: "",
      // unanumbar: "",
      // adhaar: "",
      // pan: "",
      // address: "",
      // branch: "",
      // ifscCode: "",
      // bank: "",
      // accountNumber: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,
    enableReinitialize: true,
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      // console.log("hhdgh", values);

      try {
        setOpen(true);
        const res = await common_axios.post(`/employee/v1/editEmployee`, {
          userId: Edittt?.id,
          email: values?.emailaddress ? values?.emailaddress : null,
          mobileNo: values?.contact ? values?.contact : null,
          address: values?.address ? values?.address : null,
          aadharCard: values?.adhaar?.replace(/\s/g, "")
            ? values?.adhaar?.replace(/\s/g, "")
            : null,
          accountNumber: values?.accountNumber ? values?.accountNumber : null,
          bank: values?.bank ? values?.bank : null,
          ifscCode: values?.ifscCode ? values?.ifscCode : null,
          branch: values?.branch ? values?.branch : null,
          panNumber: values?.pan ? values?.pan : null,
        });

        if (res.data.statusDescriptions.statusCode == 200) {
          setOpen(false);
          // await modalMarkClose.current.click();
          // await AllCSM();
          closeeee.current.click();
          // await formik.handleReset();
          document.getElementById("homeee-tab").click();
          // await buttonCLick.current.click();
          await getAllEmployeesbyCSM();
          // await toast.success(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // x.toLocaleDateString()
        } else {
          setOpen(false);
          closeeee.current.click();
          document.getElementById("homeee-tab").click();
          await getAllEmployeesbyCSM();
          // await toast.error(res.data.statusDescriptions.statusDescription, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        console.log(error);
        setOpen(false);
        closeeee.current.click();
        // await toast.error(
        //   "Something Went Wrong !! Please check your network ",
        //   {
        //     theme: "colored",
        //   }
        // );
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  useEffect(() => {
    //for addhar number----------------------

    document.getElementById("adh").addEventListener("input", function (e) {
      var target = e.target,
        position = target.selectionEnd,
        length = target.value.length;
      let addharVal = target.value?.replace(/\s/g, "");
      if (addharVal.length > 12) {
        target.value = addharVal.slice(0, 12);
      }
      target.value = target.value
        ?.replace(/[^\dA-Z]/g, "")
        ?.replace(/(.{4})/g, "$1 ")
        .trim();
      target.selectionEnd = position +=
        target.value.charAt(position - 1) === " " &&
        target.value.charAt(length - 1) === " " &&
        length !== target.value.length
          ? 1
          : 0;
      // console.log("target", target.value.replace(/\s/g, ""));
      formik.setFieldValue("adhaar", target.value, false);
    });
    //addhar number end --------------------
    // pan number-----------------------------
    document.getElementById("pn").addEventListener("input", function (e) {
      var target = e.target,
        position = target.selectionEnd,
        length = target.value.length;
      let addharVal = target.value?.replace(/\s/g, "");
      if (addharVal.length > 10) {
        target.value = addharVal.slice(0, 10);
      }
      target.value = target.value.toUpperCase();
      // console.log("pn", target.value);
      formik.setFieldValue("pan", target.value, false);
    });
    //pan number end ------------------------------

    document.getElementById("gml").addEventListener("input", function (e) {
      var target = e.target,
        position = target.selectionEnd,
        length = target.value.length;
      let addharVal = target.value?.replace(/\s/g, "");
      if (addharVal.length > 50) {
        target.value = addharVal.slice(0, 50);
      }
      // target.value = target.value.match(/^[A-Za-z]+$/);
      // console.log("gml", target.value);
      formik.setFieldValue("emailaddress", target.value, false);
    });
  }, []);

  // useEffect(() => {
  //   formik.setFieldValue("contact", Edittt?.mobileNo, false);
  //   formik.setFieldValue("username", Edittt?.username, false);
  //   formik.setFieldValue("emailaddress", Edittt?.email, false);
  //   formik.setFieldValue("payrollid", Edittt?.payrollId, false);
  //   formik.setFieldValue("unanumbar", Edittt?.uanNumber, false);
  //   formik.setFieldValue("adhaar", Edittt?.aadharCard, false);
  //   formik.setFieldValue("pan", EditttBankdetails?.panNumber, false);
  //   formik.setFieldValue("address", Edittt?.address, false);
  //   formik.setFieldValue("branch", EditttBankdetails?.branch, false);
  //   formik.setFieldValue("ifscCode", EditttBankdetails?.ifscCode, false);
  //   formik.setFieldValue("bank", EditttBankdetails?.bank, false);
  //   formik.setFieldValue(
  //     "accountNumber",
  //     EditttBankdetails?.accountNumber,
  //     false
  //   );

  //   // contact: "",

  //   // username: "",
  //   // emailaddress:"",

  //   // payrollid: "",
  //   // unanumbar: "",

  //   // adhaar: "",
  //   // pan: "",
  //   // address: "",
  //   // branch: "",
  //   // ifscCode:
  //   //   "",
  //   // bank: "",
  //   // accountNumber:
  //   //   "",

  //   // userId: Edittt?.id,
  //   //   email: Edittt?.email,
  //   //   mobileNo: Edittt?.mobileNo,
  //   //   address: Edittt?.address,
  //   //   aadharCard: Edittt?.aadharCard,
  //   //   accountNumber: EditttBankdetails && EditttBankdetails?.accountNumber,
  //   //   bank: EditttBankdetails && EditttBankdetails?.bank,
  //   //   ifscCode: EditttBankdetails && EditttBankdetails?.ifscCode,
  //   //   branch: EditttBankdetails && EditttBankdetails?.branch,
  //   //   panNumber: EditttBankdetails && EditttBankdetails?.panNumber,
  // }, [Edittt]);

  return (
    <>
      {" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <>
          <button
            ref={editEmployee}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop29"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop29"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    View Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          ref={tabSwitch}
                          // class="nav-link active"
                          class="nav-link active"
                          id="homee-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#homee"
                          type="button"
                          role="tab"
                          aria-controls="homee"
                          aria-selected="true"
                          // onClick={() => {
                          //   settabToggle(false);
                          // }}
                          // tabToggle={false}
                        >
                          Basic Information
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link ms-2"
                          id="profilee-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#profilee"
                          type="button"
                          role="tab"
                          aria-controls="profilee"
                          aria-selected="false"
                        >
                          Bank Details
                        </button>
                      </li>
                    </ul>
                    <div class="tab-content mt-3" id="myTabContent">
                      <div
                        class="tab-pane fade show active"
                        id="homee"
                        role="tabpanel"
                        aria-labelledby="homee-tab"
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Username:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.username}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Payroll-Id:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.payrollId}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Organisation:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.organization}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Location:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.location}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Contact No.:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.mobileNo}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              E-Mail:
                            </label>
                            <span className=""> {employeeDetails?.email}</span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Aadhar Number:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.aadharCard}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Address:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.address}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              UAN No.:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.uanNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="profilee"
                        role="tabpanel"
                        aria-labelledby="profilee-tab"
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Bank Name:
                            </label>
                            <span className=""> {EditttBankdetails?.bank}</span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Acc. No:
                            </label>
                            <span className="">
                              {" "}
                              {EditttBankdetails?.accountNumber}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Bank Branch:
                            </label>
                            <span className="">
                              {" "}
                              {EditttBankdetails?.branch}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              IFSC Code:
                            </label>
                            <span className="">
                              {" "}
                              {EditttBankdetails?.ifscCode}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              PAN No.:
                            </label>
                            <span className="">
                              {" "}
                              {EditttBankdetails?.panNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="modal-footer">
                        <button
                          // ref={modelButtonRejectClose}
                          type="button"
                          className="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            approveUserApi();
                          }}
                        >
                          Approve User
                        </button>
                      </div> */}
                  </div>
                </ThemeProvider>
                <div className="modal-footer">
                  <Button
                    data-bs-dismiss="modal"
                    type="button"
                    variant="contained"
                    sx={{ background: "#F96B02", color: "white" }}
                    endIcon={<CancelIcon />}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* edit modal -------------------------------------- */}

          <button
            ref={tabedit}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop291"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop291"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" style={{ width: "80%" }}>
              <form onSubmit={formik.handleSubmit}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Edit Details
                    </h5>

                    <button
                      ref={closeeee}
                      type="button"
                      className="btn-close"
                      id="homeee-tab"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        // markAttendacnerefrr.current.click();
                        formik.handleReset();
                        setEditttBankdetails(undefined);
                        setEdittt(undefined);
                      }}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <ThemeProvider theme={theme}>
                      {/* <form onSubmit={formik.handleSubmit} class="m-0"> */}
                      <div class="row mt-3" id="add_emp">
                        <div className="col-md-3">
                          <TextField
                            // required
                            InputProps={{
                              readOnly: true,
                            }}
                            className="w-100"
                            label="Username"
                            name="username"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.username &&
                              Boolean(formik.errors.username)
                            }
                            helperText={
                              formik.touched.username && formik.errors.username
                            }
                          />
                        </div>

                        <div className="col-md-3 mt_3">
                          <TextField
                            // required
                            InputProps={{
                              readOnly: true,
                            }}
                            className="w-100"
                            label="Payroll-Id"
                            name="payrollid"
                            variant="outlined"
                            size="small"
                            type="number"
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 6);
                            }}
                            value={formik.values.payrollid}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.payrollid &&
                              Boolean(formik.errors.payrollid)
                            }
                            helperText={
                              formik.touched.payrollid &&
                              formik.errors.payrollid
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            // required
                            className="w-100"
                            label="Contact No."
                            name="contact"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={formik.values.contact}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.contact &&
                              Boolean(formik.errors.contact)
                            }
                            helperText={
                              formik.touched.contact && formik.errors.contact
                            }
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 10);
                            }}
                          />
                        </div>

                        <div className="col-md-3 mt_3">
                          <TextField
                            // required
                            id="gml"
                            className="w-100"
                            label="E-Mail"
                            name="email"
                            variant="outlined"
                            size="small"
                            type="emailaddress"
                            value={formik.values.emailaddress}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.emailaddress &&
                              Boolean(formik.errors.emailaddress)
                            }
                            helperText={
                              formik.touched.emailaddress &&
                              formik.errors.emailaddress
                            }
                          />
                        </div>
                      </div>
                      <div class="row mt-4" id="add_emp">
                        <>
                          {/* <div className="col-md-3">
                            <Autocomplete
                              disablePortal
                              value={Designation}
                              aria-required
                              clearOnBlur={true}
                              className="w-100"
                              id="combo-box-demo"
                              size="small"
                              // options={top100Films}
                              options={Designationarray}
                              getOptionLabel={(option) =>
                                option?.designations || ""
                              }
                              onChange={(e, value) =>
                                handleChangeDesignation(value)
                              }
                              sx={{ width: 300 }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  label="Designation"
                                />
                              )}
                            />
                          </div> */}
                        </>
                      </div>

                      <div class="row mt-3" id="add_emp">
                        <div className="col-md-3">
                          <TextField
                            // disabled
                            InputProps={{
                              readOnly: true,
                            }}
                            className="w-100"
                            label="Organisation"
                            name="Organisation"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={Edittt?.organization}
                          />
                        </div>

                        <div className="col-md-3 my_3 forcss">
                          <>
                            <TextField
                              // disabled
                              InputProps={{
                                readOnly: true,
                              }}
                              className="w-100"
                              label="Location"
                              name="Location"
                              variant="outlined"
                              size="small"
                              type="text"
                              value={Edittt?.location}
                            />
                          </>

                          {/* <>
                            <FormControl className="w-100">
                              <InputLabel id="demo-multiple-checkbox-label">
                                Location
                              </InputLabel>
                              <Select
                                readOnly={true}
                                fullWidth
                                // className="w-100"
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                required
                                size="small"
                                value={personName}
                                onChange={handleChangeMultiLocation}
                                input={<OutlinedInput label="Location" />}
                                renderValue={(selected) =>
                                  selected.map((x) => x?.location).join(", ")
                                }
                                MenuProps={MenuProps}
                              >
                                {Locationarray?.map((val) => (
                                  <MenuItem key={val?.id} value={val}>
                                    <Checkbox
                                      checked={personName?.indexOf(val) > -1}
                                    />
                                    <ListItemText primary={val?.location} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </> */}
                        </div>
                        <div class="col-md-3 width_3">
                          <div class="input-group input-group-outline mrgin_">
                            <TextField
                              // required
                              className="w-100"
                              label="Address"
                              name="address"
                              variant="outlined"
                              size="small"
                              // type="email"
                              value={formik.values.address}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.address &&
                                Boolean(formik.errors.address)
                              }
                              helperText={
                                formik.touched.address && formik.errors.address
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-3 mt_3">
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            style={{ zIndex: "10px" }}
                            fullWidth
                          >
                            <DesktopDatePicker
                              minDate={dayjs(new Date())}
                              style={{ zIndex: "10px" }}
                              label="Joining Date"
                              inputFormat="MM/DD/YYYY"
                              value={joining}
                              helperText={"(Format - mm/dd/yyyy hh:mm (A/P)m)"}
                              onChange={handleChangeJoining}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  style={{ zIndex: "10px" }}
                                  required
                                  fullWidth
                                  className="w-100"
                                  {...params}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div> */}
                      </div>
                      <div className="row mt-3" id="add_emp">
                        <div class="col-md-3 width_3">
                          <div class="input-group input-group-outline mrgin_">
                            <TextField
                              // required
                              id="adh"
                              className="w-100"
                              label="Aadhaar Card Number"
                              size="small"
                              placeholder="78XX 45XX 97XX"
                              type="text"
                              name="adhaar"
                              value={formik.values.adhaar}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.adhaar &&
                                Boolean(formik.errors.adhaar)
                              }
                              helperText={
                                formik.touched.adhaar && formik.errors.adhaar
                              }
                            />
                          </div>
                        </div>

                        <div className="col-md-3">
                          <TextField
                            // required
                            InputProps={{
                              readOnly: true,
                            }}
                            className="w-100"
                            label="UAN-number"
                            name="unanumbar"
                            variant="outlined"
                            size="small"
                            type="number"
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 12);
                            }}
                            value={formik.values.unanumbar}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.unanumbar &&
                              Boolean(formik.errors.unanumbar)
                            }
                            helperText={
                              formik.touched.unanumbar &&
                              formik.errors.unanumbar
                            }
                          />
                        </div>
                      </div>
                      <Divider className="mt-3" textAlign="center">
                        <b> Bank Details</b>
                      </Divider>
                      <div className="row mt-3">
                        <div className="col-md-3">
                          <TextField
                            // required
                            className="w-100"
                            label="Account Number"
                            name="accountNumber"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={formik.values.accountNumber}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.accountNumber &&
                              Boolean(formik.errors.accountNumber)
                            }
                            helperText={
                              formik.touched.accountNumber &&
                              formik.errors.accountNumber
                            }
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 17);
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            // required
                            className="w-100"
                            label="Bank Name"
                            name="bank"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={formik.values.bank}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.bank && Boolean(formik.errors.bank)
                            }
                            helperText={
                              formik.touched.bank && formik.errors.bank
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            // required
                            className="w-100"
                            label="IFSC Code"
                            name="ifscCode"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={formik.values.ifscCode}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.ifscCode &&
                              Boolean(formik.errors.ifscCode)
                            }
                            helperText={
                              formik.touched.ifscCode && formik.errors.ifscCode
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            // required
                            className="w-100"
                            label="Branch"
                            name="branch"
                            variant="outlined"
                            size="small"
                            type="text"
                            // onInput={(e) => {
                            //   e.target.value = Math.max(
                            //     0,
                            //     parseInt(e.target.value)
                            //   )
                            //     .toString()
                            //     .slice(0, 12);
                            // }}
                            value={formik.values.branch}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.branch &&
                              Boolean(formik.errors.branch)
                            }
                            helperText={
                              formik.touched.branch && formik.errors.branch
                            }
                          />
                        </div>
                        <div class="col-md-3 width_3 mt-3">
                          <div class="input-group input-group-outline mrgin_">
                            <TextField
                              // required
                              id="pn"
                              className="w-100"
                              label="PAN Card Number"
                              size="small"
                              placeholder="ALWPG5809L"
                              //   defaultValue="Small"
                              type="text"
                              name="pan"
                              value={formik.values.pan}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.pan && Boolean(formik.errors.pan)
                              }
                              helperText={
                                formik.touched.pan && formik.errors.pan
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* </form> */}
                    </ThemeProvider>
                  </div>

                  <div className="modal-footer ">
                    <Button
                      className="d-none"
                      ref={resetValues}
                      onClick={() => {
                        formik.handleReset();
                        // setLocation({
                        //   hrcCsm: "",
                        //   csmManager: "",
                        //   locationClass: "",
                        //   status: "",
                        // });
                        // setstate("");
                        // setValue(null);
                        // setdataAutoComplete({
                        //   location: null,
                        //   org: null,
                        // });
                      }}
                      sx={{ marginLeft: "10px", background: "#4C4234" }}
                      type="reset"
                      variant="contained"
                      endIcon={<RestartAltIcon />}
                    >
                      Reset
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      // disabled={buttonDisable}
                      sx={{ background: "#F67503" }}
                      endIcon={<SendIcon />}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </form>
            </div>
            {/* <form onSubmit={editdetails}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                      Edit Details
                    </h5>
                    <button
                      ref={closeeee}
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button
                            // ref={tabSwitch}
                            // class="nav-link active"
                            class="nav-link active"
                            id="homeee-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#homeee"
                            type="button"
                            role="tab"
                            aria-controls="homeee"
                            aria-selected="true"
                            // onClick={() => {
                            //   settabToggle(false);
                            // }}
                            // tabToggle={false}
                          >
                            Basic Information
                          </button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button
                            class="nav-link ms-2"
                            id="profileee-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#profileee"
                            type="button"
                            role="tab"
                            aria-controls="profileee"
                            aria-selected="false"
                          >
                            Bank Details
                          </button>
                        </li>
                      </ul>

                      <div class="tab-content mt-3" id="myTabContent">
                        <div
                          class="tab-pane fade show active"
                          id="homeee"
                          role="tabpanel"
                          aria-labelledby="homeee-tab"
                        >
                          <div className="row">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Username:
                              </label>

                              <input
                                disabled
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.username}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    username: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Payroll-Id:
                              </label>

                              <input
                                disabled
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.payrollId}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    payrollId: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Organisation:
                              </label>

                              <input
                                disabled
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.organization}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    organization: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Location:
                              </label>

                              <input
                                disabled
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.location}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    location: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Contact No.:
                              </label>

                              <input
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.mobileNo}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    mobileNo: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                E-Mail:
                              </label>

                              <input
                                required
                                className="form-control"
                                type="email"
                                value={Edittt?.email}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    email: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Aadhar Number:
                              </label>

                              <input
                                disabled
                                required
                                pattern="/^[2-9]{1}[0-9]{3}\s[0-9]{4}\s[0-9]{4}$/"
                                className="form-control"
                                type="text"
                                value={Edittt?.aadharCard}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    aadharCard: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Address:
                              </label>

                              <input
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.address}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    address: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                UAN No.:
                              </label>

                              <input
                                disabled
                                required
                                className="form-control"
                                type="text"
                                value={Edittt?.uanNumber}
                                onChange={(e) => {
                                  setEdittt({
                                    ...Edittt,
                                    uanNumber: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="profileee"
                          role="tabpanel"
                          aria-labelledby="profileee-tab"
                        >
                          <div className="row">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Bank Name:
                              </label>

                              <input
                                required
                                className="form-control"
                                type="text"
                                value={EditttBankdetails?.bank}
                                onChange={(e) => {
                                  setEditttBankdetails({
                                    ...EditttBankdetails,
                                    bank: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Acc. No:
                              </label>
                              <span className=""> </span>
                              <input
                                required
                                className="form-control"
                                type="text"
                                value={EditttBankdetails?.accountNumber}
                                onChange={(e) => {
                                  setEditttBankdetails({
                                    ...EditttBankdetails,
                                    accountNumber: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                Bank Branch:
                              </label>

                              <input
                                required
                                className="form-control"
                                type="text"
                                value={EditttBankdetails?.branch}
                                onChange={(e) => {
                                  setEditttBankdetails({
                                    ...EditttBankdetails,
                                    branch: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                IFSC Code:
                              </label>
                              <input
                                required
                                className="form-control"
                                type="text"
                                value={EditttBankdetails?.ifscCode}
                                onChange={(e) => {
                                  setEditttBankdetails({
                                    ...EditttBankdetails,
                                    ifscCode: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label
                                for="exampleInputEmail1"
                                className="form-label fw-bolder"
                                style={{ fontSize: "13px" }}
                              >
                                PAN No.:
                              </label>
                              <input
                                required
                                className="form-control"
                                pattern="/(([A-Z]){5}([0-9]){4}([A-Z]){1}$)/"
                                type="text"
                                value={EditttBankdetails?.panNumber}
                                onChange={(e) => {
                                  setEditttBankdetails({
                                    ...EditttBankdetails,
                                    panNumber: e.target.value,
                                  });
                                }}
                              />
                              Example Like: ALWPG5809L
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ThemeProvider>
                  <div className="modal-footer">
                    <Button
                      // data-bs-dismiss="modal"
                      type="submit"
                      variant="contained"
                      sx={{ background: "#F96B02", color: "white" }}
                      // endIcon={<CancelIcon />}
                      // onClick={editdetails}
                    >
                      submit
                    </Button>
                  </div>
                </div>
              </div>
            </form> */}
          </div>

          {/* edit modal end --------------------------------------- */}

          <button
            ref={viewAttendance}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop11"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop11"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog att_table modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5
                    className="modal-title w-100 text-center"
                    id="staticBackdropLabel"
                  >
                    Attendance Details
                  </h5>
                  <button
                    onClick={() => {
                      setviewattendance(undefined);
                      setResetModal();
                    }}
                    type="button"
                    className="btn-close m-0"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    <div class="container-fluid mt-3">
                      <div class="card " id="new_store_entry">
                        <div class="card-header p-3 position-relative border-0 bg-white">
                          <DashboradTable
                            // data111={datee}
                            notshowpie={true}
                            id={viewattendance?.id}
                            resetcalnder={resetModal}
                            // userGrop={employeesValue?.userGroups}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </ThemeProvider>
                {/* <div className="modal-footer">
                      <Button
                        type="button"
                        variant="contained"
                        sx={{ background: "#F96B02", color: "white" }}
                        endIcon={<SendIcon />}
                      >
                        Edit
                      </Button>
    
                      <Button
                        data-bs-dismiss="modal"
                        sx={{ marginLeft: "10px", background: "#4C4234" }}
                        variant="contained"
                        endIcon={<CancelIcon />}
                      >
                        Close
                      </Button>
                    </div> */}
              </div>
            </div>
          </div>
          <button
            ref={markAttendacneref}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop12"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal mark fade"
            id="staticBackdrop12"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Mark Attendance
                  </h5>
                  <button
                    ref={modalMarkClose}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setValueee(null);
                      setvalueofLeavs(null);
                    }}
                  ></button>
                </div>
                <form onSubmit={markAttendacneByCSM}>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-6">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Select Date"
                              value={valueee}
                              inputFormat="DD/MM/YYYY"
                              disableFuture
                              onError={(e) => {
                                if (e) {
                                  setbuttonDisable(true);
                                } else {
                                  setbuttonDisable(false);
                                }
                              }}
                              onChange={(e) => {
                                handleChanged(e);
                              }}
                              minDate={mindate?._d}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  size="small"
                                  onKeyDown={onKeyDown}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div className="col-6">
                          <FormControl required size="small" fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Status
                            </InputLabel>
                            <Select
                              required
                              size="small"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={valueofLeavs}
                              label="Status"
                              onChange={(e) => {
                                setvalueofLeavs(e.target.value);
                              }}
                            >
                              {leavesByOthere?.map((e) => {
                                return (
                                  <MenuItem value={e?.status}>
                                    {e?.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </ThemeProvider>
                  <div className="modal-footer d-flex justify-content-between">
                    <Button
                      onClick={() => {
                        setValueee(null);
                        setvalueofLeavs("");
                      }}
                      ref={modalMarkClose}
                      data-bs-dismiss="modal"
                      sx={{ marginLeft: "10px", background: "#4C4234" }}
                      variant="contained"
                      endIcon={<CancelIcon />}
                    >
                      Close
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ background: "#F96B02", color: "white" }}
                      endIcon={<SendIcon />}
                      disabled={buttonsidable}
                    >
                      Mark
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>

        {/* ----------forgot------------------------------------- */}

        <>
          <button
            id="openForgot"
            ref={forgotRef}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop9"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop9"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Reset Password
                  </h5>
                  <button
                    ref={forgotRefmodal}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setContactus({
                        // name: "",
                        // email: "",
                        userid: "",
                        username: "",
                        newpassword: "",
                        confirmpassword: "",
                      });
                    }}
                  ></button>
                </div>
                <form onSubmit={forgotPassword}>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body" id="reset_pwd_modal">
                      <div className="row">
                        <div className="col-md-9">
                          <div className="d-flex align-items-center">
                            {/* <label
                              className="m-0"
                              htmlFor=""
                              style={{ whiteSpace: "nowrap" }}
                            >
                              E-Mail
                            </label>                
                            <input
                              class="form-control w-100 ms-4"
                              type="email"
                              required
                              value={contactus.email}
                              onChange={(e) => {
                                setContactus({
                                  ...contactus,
                                  email: e.target.value,
                                });
                              }}
                            /> */}
                            <label
                              className="m-0"
                              htmlFor=""
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Username
                            </label>
                            <input
                              class="form-control w-100 ms-4"
                              type="newpassword"
                              disabled
                              required
                              value={contactus.username}
                              onChange={(e) => {
                                setContactus({
                                  ...contactus,
                                  username: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-9">
                          <div className="d-flex align-items-center">
                            {/* <label
                              className="m-0"
                              htmlFor=""
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Username
                            </label>
                            <input
                              required
                              class="form-control w-100 ms-4"
                              type="text"
                              value={contactus.name}
                              onChange={(e) => {
                                setContactus({
                                  ...contactus,
                                  name: e.target.value,
                                });
                              }}
                            /> */}
                            <label
                              className="m-0"
                              htmlFor=""
                              style={{ whiteSpace: "nowrap" }}
                            >
                              New Password
                            </label>
                            <div class="ms-4 w-100 d-flex">
                              <input
                                class="form-control w-100"
                                type={showPassword ? "text" : "password"}
                                required
                                value={contactus.newpassword}
                                onChange={(e) => {
                                  setContactus({
                                    ...contactus,
                                    newpassword: e.target.value,
                                  });
                                }}
                              />
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                  backgroundColor: "rgb(232 240 254 / 26%)",
                                  borderRadius: "0 0.375rem 0.375rem 0",
                                }}
                              >
                                {showPassword ? (
                                  <VisibilityIcon sx={{ color: "#F96B02" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ color: "#F96B02" }}
                                  />
                                )}
                              </IconButton>
                            </div>
                            {/* <div className="col-12">
                              <label
                                for="inputPassword2"
                                className="wifiLable text-white"
                              >
                                New Password
                              </label>
                              <div className="d-flex">
                                <input
                                  required
                                  type={showPassword ? "text" : "password"}
                                  className="form-control p-2 text-white"
                                  id="passwordifany"
                                  style={{
                                    borderBottomRightRadius: "0px",
                                    borderTopRightRadius: "0px",
                                  }}
                                  // placeholder="Enter Profile Password"
                                  autocomplete="new-password"
                                  value={contactus.newpassword}
                                  onChange={(e) => {
                                    setContactus({
                                      ...contactus,
                                      newpassword: e.target.value,
                                    });
                                  }}
                                />
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  style={{
                                    backgroundColor: "rgb(232 240 254 / 26%)",
                                    borderRadius: "0 0.375rem 0.375rem 0",
                                  }}
                                >
                                  {showPassword ? (
                                    <VisibilityIcon sx={{ color: "#1990d0" }} />
                                  ) : (
                                    <VisibilityOffIcon
                                      sx={{ color: "#1990d0" }}
                                    />
                                  )}
                                </IconButton>
                              </div>
                        
                            </div> */}
                          </div>
                        </div>
                      </div>
                      {/* <div className="row mt-3">
                        <div className="col-md-9">
                          <div className="d-flex align-items-center">
                            <label
                              className="m-0"
                              htmlFor=""
                              style={{ whiteSpace: "nowrap" }}
                            >
                              Confirm Password
                            </label>
                            <input
                              class="form-control w-100 ms-4"
                              type="newpassword"
                              required
                              value={contactus.confirmpassword}
                              onChange={(e) => {
                                setContactus({
                                  ...contactus,
                                  confirmpassword: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </ThemeProvider>
                  <div className="px-2 pb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <Button
                        data-bs-dismiss="modal"
                        sx={{ marginLeft: "10px", background: "#4C4234" }}
                        variant="contained"
                        endIcon={<CancelIcon />}
                        onClick={() => {
                          // setContactus({
                          //   name: "",
                          //   email: "",
                          // });
                          setContactus({
                            // name: "",
                            // email: "",
                            userid: "",
                            username: "",
                            newpassword: "",
                            confirmpassword: "",
                          });
                        }}
                      >
                        Close
                      </Button>
                      <Button
                        // data-bs-dismiss="modal"
                        type="submit"
                        variant="contained"
                        sx={{ background: "#F96B02", color: "white" }}
                        endIcon={<SendIcon />}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>

        {/* modal of enable disable */}

        <button
          ref={approvvalEnable}
          type="button"
          className="btn btn-primary d-none"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop91"
        >
          Launch static backdrop modal
        </button>

        <div
          className="modal mark fade"
          id="staticBackdrop91"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Status
                </h5>
                <button
                  // ref={markAttendacneref}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  // onClick={() => {
                  //   setstateofButtons({
                  //     approval: false,
                  //     reject: false,
                  //   });
                  // }}
                ></button>
              </div>
              <ThemeProvider theme={theme}>
                <div className="modal-body">
                  {enabledisable?.enabled == true ? (
                    <>
                      <h5> Are you sure to disable ?</h5>
                    </>
                  ) : (
                    <>
                      <h5> Are you sure to enable ?</h5>
                    </>
                  )}
                </div>
              </ThemeProvider>
              <div className="modal-footer d-flex justify-content-between align-items-center">
                <Button
                  data-bs-dismiss="modal"
                  sx={{ marginLeft: "10px", background: "#4C4234" }}
                  variant="contained"
                  // endIcon={<CancelIcon />}
                  // onClick={() => {
                  //   setstateofButtons({
                  //     approval: false,
                  //     reject: false,
                  //   });
                  // }}
                >
                  No
                </Button>
                <Button
                  data-bs-dismiss="modal"
                  sx={{ marginLeft: "10px", background: "#F96902" }}
                  variant="contained"
                  // endIcon={<CheckCircleIcon />}
                  onClick={() => {
                    EnableDisabled();
                  }}
                >
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </div>
        {/* end of the modal */}

        {/* ------------forgot end----------------------------------- */}

        <div class="container-fluid ">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 mx-7">
                <p>Manage Employee</p>

                {/* <p class="text-sm mb-0 text-capitalize fw-bold">
                      Fields mark with!!
                      <span class="text-danger fw-bold">*</span> are mandatory.
                    </p> */}
              </div>
            </div>

            <div class="card-body p-4 mt-5 tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="card card_8 d-block">
                  <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                    <i class="fas fa-envelope d-block" aria-hidden="true"></i>

                    <span class="d-block w-100 text-start text-uppercase ms-2">
                      Manage Employee
                    </span>
                  </div>

                  <div class="card-body">
                    <div className="formisform">
                      <>
                        {JSON.parse(localStorage.getItem("usermodal"))
                          ?.userGroups != 6 ? (
                          // <div
                          //   className="row main_pu_Div"
                          //   style={{ justifyContent: "space-between" }}
                          // >
                          <>
                            <ThemeProvider theme={theme}></ThemeProvider>
                            <div className="text-end me-4">
                              {data.length > 0 &&
                                null
                                // <Button
                                //   onClick={() => {
                                //     if (selectedFlatRows.length == 0) {

                                //       Swal.fire({
                                //         icon: "error",

                                //         text: "Please Select Any Employee First",

                                //       });
                                //     } else {
                                //       markAttendacnmodal();
                                //       deletUser();
                                //     }
                                //   }}

                                //   variant="contained"
                                //   style={{ background: "#F67503" }}
                                // >
                                //   Mark In
                                // </Button>
                              }
                            </div>
                          </>
                        ) : null}
                      </>

                      <div className="card mb-3 mt-4 shadow-n">
                        {data.length > 0 ? (
                          <>
                            <div className="card-body p-4 pt-1">
                              <div className="d-flex justify-content-between">
                                <select
                                  value={pageSize}
                                  className="dropdown"
                                  onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                  }}
                                >
                                  {[10, 25, 50].map((value, i) => {
                                    return (
                                      <option
                                        aria-labelledby="dropdownMenuButton1"
                                        value={value}
                                        key={value}
                                      >
                                        {" "}
                                        Show {value}
                                      </option>
                                    );
                                  })}
                                </select>

                                <TextField
                                  className="ms-4 "
                                  sx={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Search"
                                  name="Search"
                                  variant="outlined"
                                  // value={number}
                                  size="small"
                                  value={globalSearchValue || ""}
                                  onChange={(e) => {
                                    onChange(e.target.value);
                                    setGlobalSearchValue(e.target.value);
                                  }}
                                />
                              </div>

                              <div className="table-responsive t_responsive mt-3">
                                <table
                                  {...getTableProps()}
                                  id="example"
                                  className="table table-striped table-bordered dataTable table-sm table-responsive"
                                >
                                  <thead>
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            className="text-center width_2"
                                          >
                                            {column.render("Header")}
                                            <span>
                                              {column.isSorted
                                                ? column.isSortedDesc
                                                  ? "↑"
                                                  : "↓"
                                                : ""}
                                            </span>
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody id="sub-menu" {...getTableBodyProps()}>
                                    {page.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()}>
                                          {row.cells.map((cell) => {
                                            return (
                                              <td
                                                {...cell.getCellProps()}
                                                className="text-center"
                                              >
                                                {cell.render("Cell")}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                  <span>
                                    Page:
                                    <strong>
                                      &nbsp; {pageIndex + 1} of{" "}
                                      {pageOptions.length}
                                    </strong>
                                  </span>
                                </div>

                                <div id="Nikhil">
                                  <button
                                    className="btn btn_primary m-0 ms-2"
                                    type="button"
                                    style={{
                                      background: "#4C4234",
                                    }}
                                    disabled={!canPreviousPage}
                                    onClick={() => {
                                      previousPage();
                                    }}
                                  >
                                    Prev
                                  </button>

                                  <button
                                    className="btn btn_primary m-0 ms-2"
                                    type="button"
                                    style={{
                                      background: "#F67503",
                                    }}
                                    disabled={!canNextPage}
                                    onClick={() => {
                                      nextPage();
                                    }}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : data?.length == 0 &&
                          open == null &&
                          notdatafound == true ? (
                          <div className="card-body">
                            <div>
                              <h5 style={{ textAlign: "center" }}>
                                No Data Available
                              </h5>
                            </div>
                          </div>
                        ) : data?.length == 0 && open ? (
                          null &&
                          notdatafound ==
                            true(
                              <div className="card-body">
                                <div>
                                  <h5 style={{ textAlign: "center" }}>
                                    No Data Available
                                  </h5>
                                </div>
                              </div>
                            )
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
